<template>
  <div class="relative w-full lg:h-[70vh] h-[30vh]">
    <!-- Background Image -->
    <div class="absolute inset-0 overflow-hidden">
      <img
        src="../assets/images/HERO Pages ALL 2.png"
        alt="Background"
        class="w-full h-full object-cover"
      />
      <div class="absolute inset-0 bg-black opacity-50"></div>
    </div>

    <!-- Content Wrapper -->
    <div
      class="relative max-w-screen-4xl mx-auto h-full flex flex-col lg:flex-row items-center justify-center px-6 lg:px-32"
    >
      <h2
        class="text-white text-center text-3xl font-black animate__animated animate__backInLeft"
      >
        Contact Us
      </h2>
    </div>

    <!-- SVG Curve (Aligned to Background) -->
    <svg viewBox="0 0 1440 320" class="absolute bottom-0 left-0 w-full">
      <path
        fill="#ffffff"
        d="M0,224L80,208C160,192,320,160,480,176C640,192,800,256,960,266.7C1120,277,1280,235,1360,213.3L1440,192V320H0Z"
      ></path>
    </svg>
  </div>

  <!-- The text and form setion -->
  <div
    class="md:px-10 max-w-screen-4xl mx-auto relative z-10 mt-4 px-6 lg:-mt-20"
  >
    <!-- Title Section -->
    <div class="strategic-card lg:px-14">
      <h2 class="text-yellow text-2xl who-style">Get In Touch</h2>
    </div>

    <div class="px-6 md:px-10 max-w-screen-4xl mx-auto">
      <div class="grid grid-cols-1 lg:grid-cols-2 gap-10 mt-10 py-10">
        <!-- Contact Info -->
        <div>
          <p class="text-gray-600 mt-4">
            Do you have questions or suggestions? Reach out to us! Our team is
            ready to assist you. Contact us for prompt and friendly support.
            Let's connect today!
          </p>

          <div class="mt-6 flex flex-col md:flex-row gap-2 items-stretch">
            <div class="flex-1 flex items-center gap-4 p-4 border rounded-lg">
              <div class="p-2 bg-yellow w-8 h-8 flex items-center justify-center rounded-full">
                <i class="fa-solid fa-phone text-lg text-white"></i>
              </div>
              <div>
                <p class="font-semibold">Contact Us</p>
                <a
                  href="tel:+2348104444229"
                  class="text-blue-500 hover:underline"
                >
                  +234-810-444-4229
                </a>
              </div>
            </div>

            <div class="flex-1 flex items-center gap-4 p-4 border rounded-lg">
              <div class="p-2 bg-yellow w-8 h-8 flex items-center justify-center rounded-full">
                <i class="fa-solid fa-envelope text-lg text-white"></i>
              </div>
              <div>
                <p class="font-semibold">Send Message</p>
                <a
                  href="mailto:info@mshelhomes.com"
                  class="text-blue-500 hover:underline"
                >
                  info@mshelhomes.com
                </a>
              </div>
            </div>
          </div>

          <!-- Social Media -->
          <div class="mt-10">
            <p class="font-semibold">Follow Us</p>
            <div class="flex gap-3 mt-2">
              <a
                href="https://www.facebook.com/MshelHomes/"
                class="bg-yellow text-white rounded-full hover:bg-black w-8 h-8 flex items-center justify-center"
              >
                <i class="fa-brands fa-facebook text-lg"></i>
              </a>
              <a
                href="https://www.linkedin.com/company/mshel-homes-limited"
                class="bg-yellow text-white rounded-full hover:bg-black w-8 h-8 flex items-center justify-center"
              >
                <i class="fa-brands fa-linkedin text-lg"></i>
              </a>
              <a
                href="https://www.youtube.com/@mshelhomes"
                class="bg-yellow text-white rounded-full hover:bg-black w-8 h-8 flex items-center justify-center"
              >
                <i class="fa-brands fa-youtube text-lg"></i>
              </a>
              <a
                href="https://www.instagram.com/mshelhomes/"
                class="bg-yellow text-white rounded-full hover:bg-black w-8 h-8 flex items-center justify-center"
              >
                <i class="fa-brands fa-instagram text-lg"></i>
              </a>
              <a
                href="https://twitter.com/mshelofficial"
                class="bg-yellow text-white rounded-full hover:bg-black w-8 h-8 flex items-center justify-center"
              >
                <i class="fa-brands fa-twitter text-lg"></i>
              </a>
              <a
                href="https://www.tiktok.com/@mshelhomes"
                class="bg-yellow text-white rounded-full hover:bg-black w-8 h-8 flex items-center justify-center"
              >
                <i class="fa-brands fa-tiktok text-lg"></i>
              </a>
            </div>
          </div>
        </div>

        <!-- Contact Form -->
        <div class="bg-white p-6 md:p-8 rounded-lg shadow-lg max-w-lg mx-auto lg:-mt-40 z-10 strategic-card">
          <form class="space-y-4">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
              <input
                type="text"
                placeholder="First Name"
                class="w-full p-2 border border-1 rounded-md text-xs"
              />
              <input
                type="text"
                placeholder="Last Name"
                class="w-full p-2 border rounded-md text-xs"
              />
            </div>
            <input
              type="email"
              placeholder="Email"
              class="w-full p-2 border rounded-md text-xs"
            />
            <input
              type="tel"
              placeholder="Phone Number"
              class="w-full p-2 border rounded-md text-xs"
            />
            <textarea
              placeholder="Leave a message here!"
              class="w-full p-2 border rounded-md h-28 text-xs"
            ></textarea>
            <button
              type="submit"
              class="w-full bg-yellow text-white py-2 rounded-md transition"
            >
              Submit Form
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>

  <!-- Other section -->
  <faqSection />
</template>

<script>
import faqSection from "../components/faqSection.vue";

export default {
  components: {
    faqSection,
  },
  data() {
    return {};
  },
  mounted() {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("fade-in");
          } else {
            entry.target.classList.remove("fade-in");
          }
        });
      },
      {
        threshold: 0.2, // Adjust for smoother animation trigger
      }
    );

    document
      .querySelectorAll(".strategic-card")
      .forEach((card) => observer.observe(card));
  },
};
</script>

<style scoped>
svg path {
  fill: #ffffff !important;
  stroke: none !important;
  box-shadow: none !important;
}

svg {
  overflow: hidden !important;
}

.absolute.bottom-0 {
  line-height: 0 !important;
  padding-bottom: 0 !important;
  margin-bottom: -2px;
}

.overflow-hidden {
  overflow: hidden !important;
}

.who-style {
  font-family: Montserrat;
}

.strategic-card {
  opacity: 0;
  transform: translateY(50px);
  transition: opacity 1s ease-out, transform 1s ease-out;
  will-change: opacity, transform;
}

.strategic-card.fade-in {
  opacity: 1;
  transform: translateY(0);
}

.strategic-card:hover {
  transform: scale(1.03);
  /* box-shadow: 0 15px 30px rgba(0, 0, 0, 0.2); */
  transition: transform 0.4s ease-out, box-shadow 0.4s ease-out;
  /* background-color: inherit !important; */
  box-shadow: none !important;
}
</style>
